import { SportsbookEventEffects } from "@sports-features/event/stores/event.effects";
import { SportsbookHomeEffects } from "@sports-features/home/stores/home.effects";
import { SportsbookLiveMarketEffects } from "@sports-features/live-market/stores/live-market.effects";
import { SportsbookLiveEffects } from "@sports-features/live/stores/live.effects";
import { SportsbookMarketEffects } from "@sports-features/market-page/stores/market.effects";
import { SportsbookRaceMarketEffects } from "@sports-features/race-market/stores/race-market.effects";
import { SportsbookRaceEffects } from "@sports-features/race/stores/race.effects";
import { SportsbookSportCountriesEffects } from "@sports-features/sport-countries/stores/sport-countries.effects";
import { SportsbookTodayEffects } from "@sports-features/today/stores/today.effects";
import { SportsbookErrorEffects } from "./common-effects/error.effects";
import { SportsbookInitEffects } from "./common-effects/init.effects";
import { SportsbookNavigationEffects } from "./common-effects/navigation.effects";

export const SportsbookEffects = [
  SportsbookHomeEffects,
  SportsbookSportCountriesEffects,
  SportsbookEventEffects,
  SportsbookMarketEffects,
  SportsbookTodayEffects,
  SportsbookLiveMarketEffects,
  SportsbookLiveEffects,
  SportsbookRaceEffects,
  SportsbookRaceMarketEffects,
  SportsbookNavigationEffects,
  SportsbookInitEffects,
  SportsbookErrorEffects,
];
